module.exports = __webpack_public_path__ + "static/img/logo--circle.e3f37a6a.png";